import React from "react"
import { Formik, Form as FormikForm, Field } from "formik"
import { Row } from "react-bootstrap"
import * as Yup from "yup"
import FormTextbox from "../../shared/formTextbox"
import FormFieldDisableAutoComplete from "../../shared/formFieldDisableAutoComplete"
import FormRadioButton from "../../shared/formRadioButton"
import FormDatePickerTextBox from "../../shared/formDatePickerTextBox"
import FormTimeTextBox from "../../shared/formTimeTextBox"
import FormSectionTitle from "../../shared/formSectionTitle"
import FormAmountTextBox from "../../shared/formAmountTextBox"

// import FormDropdownList from "../../shared/formDropdownList"
import FormEditUpload from "../../shared/formEditUpload"

import {
  controlEditBenefit,
  updateValidBenfitFormData,
  updateClickedNext,
  updateFormIsValid,
  pageIncrement,
  completeBenefitForm,
} from "../../../redux/actions"

import * as Constants from "../../../common/constants"
import * as Regex from "../../../common/regex"
import * as ErrorMessage from "../../../common/errorMessage"
import * as CommonFunction from "../../../common/function"
import * as Alert from "../../../services/sweetalertService"

import { useDispatch, useSelector, shallowEqual, batch } from "react-redux"

const HospitalAllowanceForm = React.memo(({ coverageDetail }) => {
  const dispatch = useDispatch()
  const formRef = React.useRef()

  const {
    editBenefits,
    allProofDocuments,
    claimUploadListModel,
    clickedNext,
    isComeWithChildCoverage,
    tempBenefitInfo,
    pageNumber,
    chosenedBenefits,
  } = useSelector(state => state.uiData)

  const claimData = useSelector(state => state.claimData, shallowEqual)

  const {
    Category: coverageCategory,
    CoverageCode: coverageCode,
    CoverageDetailId: coverageDetailId,
    CoverageDetailName: coverageDetailName,
  } = coverageDetail

  const formName = coverageCode

  useSelector(state => {
    if (!state.claimData[coverageCategory][coverageCode]) {
      state.claimData[coverageCategory][coverageCode] = {}
    }
  }, shallowEqual)

  //   occurrenceDate: "",
  //   occurrenceLocation: "",
  //   occurrenceNature: "",
  //   admissionDate: "",
  //   admissionTime: "",
  //   dischargeDate: "",
  //   dischargeTime: "",
  //   claimAmount: "",

  const validationSchema = Yup.object().shape({
    occurrenceDate: Yup.date().required(ErrorMessage.HospitalAccidentDate),

    occurrenceLocation: Yup.string().required(
      ErrorMessage.HospitalAccidentLocation
    ),

    occurrenceNature: Yup.string().required(
      ErrorMessage.HospitalAccidentNature
    ),

    admissionDate: Yup.date()
      .required(ErrorMessage.HospitalAdmissionDate)
      .test(
        "admissionDate",
        ErrorMessage.HospitalAdmissionEarlierThanAccident,
        value => {
          return CommonFunction.isAfterDateTime(
            formRef.current.values.occurrenceDate,
            "00:00",
            value,
            "00:00"
          )
        }
      ),

    admissionTime: Yup.string()
      .required(ErrorMessage.HospitalAdmissionTime)
      .matches(Regex.timepattern, ErrorMessage.HospitalAdmissionTime)
      .test("admissionTime", ErrorMessage.futureTimeErrorMsg, value => {
        return CommonFunction.notFutureDatime(
          formRef.current.values.admissionDate,
          value
        )
      })
      .test(
        "admissionTime",
        ErrorMessage.HospitalAdmissionEarlierThanAccident,
        value => {
          return CommonFunction.isAfterDateTime(
            formRef.current.values.occurrenceDate,
            "00:00",
            formRef.current.values.admissionDate,
            value
          )
        }
      ),

    dischargeDate: Yup.date()
      .required(ErrorMessage.HospitalDischargeDate)
      .test(
        "dischargeDate",
        ErrorMessage.HospitalDischargeEarlierThanAccident,
        value => {
          return CommonFunction.isAfterDateTime(
            formRef.current.values.occurrenceDate,
            "00:00",
            value,
            "00:00"
          )
        }
      )
      .test(
        "dischargeDate",
        ErrorMessage.HospitalDischargeEarlierThanAdmission,
        value => {
          return CommonFunction.isAfterDateTime(
            formRef.current.values.admissionDate,
            "00:00",
            value,
            "00:00"
          )
        }
      ),

    dischargeTime: Yup.string()
      .required(ErrorMessage.HospitalDischargeTime)
      .matches(Regex.timepattern, ErrorMessage.HospitalDischargeTime)
      .test("dischargeTime", ErrorMessage.futureTimeErrorMsg, value => {
        return CommonFunction.notFutureDatime(
          formRef.current.values.dischargeDate,
          value
        )
      })
      .test(
        "dischargeTime",
        ErrorMessage.HospitalDischargeEarlierThanAccident,
        value => {
          return CommonFunction.isAfterDateTime(
            formRef.current.values.occurrenceDate,
            formRef.current.values.occurrenceTime,
            formRef.current.values.dischargeDate,
            value
          )
        }
      )
      .test(
        "dischargeTime",
        ErrorMessage.HospitalDischargeEarlierThanAdmission,
        value => {
          return CommonFunction.isAfterDateTime(
            formRef.current.values.admissionDate,
            formRef.current.values.admissionTime,
            formRef.current.values.dischargeDate,
            value
          )
        }
      ),

    claimAmount: Yup.number()
      .transform(value => (isNaN(value) ? undefined : value))
      .min(1, ErrorMessage.claimAmount),
  })

  return (
    <Formik
      initialValues={Object.assign(
        {
          occurrenceDate: "",
          occurrenceLocation: "",
          occurrenceNature: "",
          admissionDate: "",
          admissionTime: "",
          dischargeDate: "",
          dischargeTime: "",
          claimAmount: 0,
        },
        claimData[coverageCategory][coverageCode]
      )}
      enableReinitialize={true}
      validationSchema={validationSchema}
      validateOnMount={true}
      innerRef={formRef}
      onSubmit={(values, actions) => {}}
    >
      {({ handleSubmit, values }) => (
        <>
          <FormikForm onSubmit={handleSubmit}>
            {
              <Row
                className={
                  "form-group " + (editBenefits[coverageCode] ? "" : "hide")
                }
              >
                <div className="col-md-9 col-7 textforinput marginTop10px benefitEditTitle">
                  <p>{coverageDetailName}</p>
                </div>
                <div className="col-md-3 col-5 marginTop10px">
                  <div
                    className="cursorPointer"
                    role="button"
                    tabIndex="0"
                    onClick={() => dispatch(controlEditBenefit(coverageCode))}
                  >
                    <p className="doneEdit">DONE EDIT</p>
                  </div>
                </div>
              </Row>
            }
            {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
            <Field
              textDesc={"Disable Auto Complete"}
              name="disableAutoComplete"
              component={FormFieldDisableAutoComplete}
            />
            <Field
              textDesc={"Date of Accident"}
              name="occurrenceDate"
              component={FormDatePickerTextBox}
            />

            <Field
              textDesc={"Location of Accident"}
              maxLength={100}
              name="occurrenceLocation"
              component={FormTextbox}
            />

            <Field
              textDesc={"Nature of Accident"}
              maxLength={200}
              name="occurrenceNature"
              component={FormTextbox}
            />

            <Field
              textDesc={"Admission Date"}
              name="admissionDate"
              component={FormDatePickerTextBox}
            />

            <Field
              textDesc="Admission Time"
              name="admissionTime"
              component={FormTimeTextBox}
            />

            <Field
              textDesc={"Discharge Date"}
              name="dischargeDate"
              component={FormDatePickerTextBox}
            />

            <Field
              textDesc="Discharge Time"
              name="dischargeTime"
              component={FormTimeTextBox}
            />

            <Field
              textDesc={"Amount Claimed(SGD)"}
              maxLength={14}
              name="claimAmount"
              component={FormAmountTextBox}
            />

            <FormEditUpload
              editBenefits={editBenefits[coverageCode]}
              coverageDetailId={coverageDetailId}
              coverageDetailName={coverageDetailName}
              allProofDocuments={allProofDocuments}
              claimUploadListModel={claimUploadListModel}
            />

            <HandleFormValidation
              thisPageClickedNext={clickedNext[Constants.benefitFormPageNumber]}
              reviewPageClickedNext={clickedNext[Constants.reviewPageNumber]}
              formRef={formRef}
              values={values}
              thisPageNumber={Constants.benefitFormPageNumber}
              dispatch={dispatch}
              formName={formName}
              coverageCategory={coverageCategory}
              coverageCode={coverageCode}
              tempBenefitInfo={tempBenefitInfo}
              chosenedBenefits={chosenedBenefits}
            />
            <HandleClaimAmountUpdate
              claimAmount={values.claimAmount}
              dispatch={dispatch}
              pageNumber={pageNumber}
              coverageCategory={coverageCategory}
              coverageCode={coverageCode}
              formRef={formRef}
            />
          </FormikForm>
        </>
      )}
    </Formik>
  )
})

const HandleFormValidation = ({
  thisPageClickedNext,
  reviewPageClickedNext,
  formRef,
  values,
  thisPageNumber,
  dispatch,
  formName,
  coverageCategory,
  coverageCode,
  tempBenefitInfo,
  chosenedBenefits,
}) => {
  React.useEffect(() => {
    if (
      (thisPageClickedNext && coverageCode === tempBenefitInfo.CoverageCode) ||
      (reviewPageClickedNext &&
        CommonFunction.checkBenefitChosened(chosenedBenefits, coverageCode))
    ) {
      // console.log(formRef.current)
      formRef.current.validateForm().then(errors => {
        // console.log(errors)

        batch(() => {
          if (Object.entries(errors).length === 0) {
            // console.log("PASS")

            dispatch(
              updateValidBenfitFormData(coverageCategory, coverageCode, values)
            )
            if (thisPageClickedNext) {
              dispatch(pageIncrement())
              dispatch(completeBenefitForm(coverageCode))
            } else {
              dispatch(updateFormIsValid(formName, true))
            }
          } else {
            if (thisPageClickedNext) {
              Alert.missingInfoAlert()
            } else {
              dispatch(updateFormIsValid(formName, false))
            }
            formRef.current.submitForm() // Set touched to all fields
          }

          dispatch(updateClickedNext(thisPageNumber, false))
        })
      })
    }
  }, [
    thisPageClickedNext,
    reviewPageClickedNext,
    formRef,
    values,
    thisPageNumber,
    dispatch,
    formName,
    coverageCategory,
    coverageCode,
    tempBenefitInfo,
  ])
  return null
}

const HandleClaimAmountUpdate = ({
  claimAmount,
  dispatch,
  pageNumber,
  coverageCategory,
  coverageCode,
  formRef,
}) => {
  React.useEffect(() => {
    if (pageNumber === Constants.reviewPageNumber) {
      setTimeout(() => {
        batch(() => {
          dispatch(
            updateValidBenfitFormData(
              coverageCategory,
              coverageCode,
              formRef.current.values
            )
          )
        })
      }, 1000)
    }
  }, [claimAmount])

  return null
}

export default HospitalAllowanceForm
